<template>
  <div class="score_man-root">
    <div class="main-content-wrap">
      <div class="nav_filter_wrap">
        <div class="up_wrap">
          <div class="icon" @click="goBack">
            <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
          </div>
          <div class="main_wrap">
            <div class="left">
              <a
                v-for="(item, index) in nav"
                :key="index"
                :class="{ btn: true, active: index == idx }"
                @click="switchTab(index)"
                >{{ item.name }}</a
              >
            </div>
            <div class="right">
              <span v-if="!isFive" class="score_his" @click="toSocreHis">已入库成绩</span>
            </div>
          </div>
        </div>
        <div class="down_wrap" style="display:flex;height: 40px;justify-content: space-between;align-items: center;">
          <div class="filter_line" style="font-size:15px">
            <span>级别：</span>
            <div
              v-for="(item, index) in class_levels"
              :key="index"
              class="level_fox"
            >
              <el-badge :is-dot="levelList.includes(item.value)">
                <a
                  @click="switchType('class_level', item.value)"
                  :class="{
                    item: true,
                    active: selectVal.class_level == item.value,
                  }"
                  :key="item.value"
                  :is-dot="levelList.includes(item.value)"
                >
                  {{ item.key }}
                </a>
              </el-badge>
            </div>
          </div>
        </div>
      </div>
      <div class="classMain">
        <div class="searchWrap">
          <div class="selectWrap">
            <select v-model="selectVal.class_train_type" @change="search">
              <option value="">全部类型</option>
              <option
                v-for="(item, index) in classTrainTypeList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.key }}
              </option>
            </select>
            <select v-model="selectVal.org_id" @change="search">
              <option value="">全部机构</option>
              <option
                v-for="(item, index) in organization"
                :key="index"
                :value="item.org_id"
              >
                {{ item.name }}
              </option>
            </select>
            <select
              v-show="idx == 3"
              v-model="selectVal.status"
              @change="search"
            >
              <option value="">全部状态</option>
              <option
                v-for="(item, index) in selectStatus"
                :key="item.value"
                :value="item.value"
              >
                {{ item.key }}
              </option>
            </select>
            <select
              v-show="idx == 3 || idx == 2"
              v-model="selectVal.year"
              @change="search"
            >
              <option value="">全部年份</option>
              <option v-for="(item) in yearList"
                :key="item.value"
                :value="item.value">{{ item.value }}年
              </option>
            </select>
          </div>
          <div class="search">
            <div class="wrap">
              <input
                type="text"
                placeholder="请输入搜索内容"
                v-model.lazy="selectVal.keywords"
                @keyup.enter="search"
              />
              <div
                v-show="selectVal.keywords != ''"
                class="close"
                @click="hideIcon"
              >
                <v-icon name="regular/times-circle" scale="1.2"></v-icon>
              </div>
            </div>
            <div class="searchBtn" @click="search">搜索</div>
          </div>
        </div>
        <yioks-loading v-show="isLoading"></yioks-loading>
        <template v-if="!isLoading">
          <template v-if="showList">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th index"><strong>序号</strong></div>
                  <div class="th org"><strong>机构名称</strong></div>
                  <div class="th level"><strong>级别</strong></div>
                  <div class="th periods"><strong>期数(详情)</strong></div>
                  <div class="th date"><strong>培训日期</strong></div>
                  <div class="th status"><strong>状态</strong></div>
                  <div class="th opt"><strong>操作</strong></div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll :ops="ops" ref="vs">
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        class="tr"
                        v-for="(item, index) in list"
                        :key="index"
                      >
                        <!--<div class="td class_name">-->
                        <!--<p @click="lookOver(item.c_id)"-->
                        <!--:title="item.name" v-if="item.is_repetition_stu == '1'" class="repetition_stu">{{ item.name }}</p>-->
                        <!--<p @click="lookOver(item.c_id)"-->
                        <!--:title="item.name" v-else>{{ item.name }}</p>-->
                        <!--</div>-->
                        <div class="td index">
                          <p>{{ index +1 }}</p>
                        </div>
                        <div class="td org">
                          <p :title="item.org_name">{{ item.org_name }}</p>
                        </div>
                        <div class="td level">
                          <span v-if="item.is_special_train === 1">【快】</span>
                          <span v-if="item.class_level === 'E'">D级助理</span>
                          <span v-else-if="['GC', 'GB', 'GA','F1','F2','PRO' ].includes( item.class_level)">{{item.class_level | classInfoBoxLevelFilter(isFive)}}</span>
                          <span v-else>{{item.class_level | classInfoBoxLevelFilter(isFive)}}级</span>
                        </div>
                        <div class="td periods">
                          <p
                            @click="lookOver(item.c_id)"
                            :class="{
                              unusual_err:
                                item.is_score_unusual_stu == '1' &&
                                item.is_repetition_stu == '0',
                              repetition_err:
                                item.is_repetition_stu == '1' &&
                                item.is_score_unusual_stu == '0',
                              both_err:
                                item.is_repetition_stu == '1' &&
                                item.is_score_unusual_stu == '1',
                              passClass_suc:
                                item.is_repetition_stu == '0' &&
                                item.is_score_unusual_stu == '0',
                            }"
                            :title="
                              item.is_score_unusual_stu
                                | tipMsg(item.is_repetition_stu)
                            "
                          >
                            第{{ item.periods }}期
                          </p>
                        </div>
                        <div class="td date">
                          <p>
                            {{ item.start_date | time(false) }} 至
                            {{ item.end_date | time(false) }}
                          </p>
                        </div>
                        <div class="td status">
                          <p>
                            <span>{{ item.status | classStatus }}</span>
                          </p>
                        </div>
                        <!-- 废弃： 五人制、讲师继续教育 不允许审核 v-if="item.class_train_type === 'teacher_train' || (idx == 0 && isFive)" -->
                        <!-- 讲师继续教育,L1 不允许审核  -->
                        <template
                          v-if="(item.class_train_type === 'teacher_train') && idx == 0 "
                        >
                          <div class="td opt">
                            <p
                              :class="{
                                isEducation: true,
                              }"
                              :title="
                                item.is_score_unusual_stu
                                  | tipMsg(item.is_repetition_stu)
                              "
                            >
                              审核
                            </p>
                          </div>
                        </template>
                        <!-- 审核页 守门员继续教育不允许审核 -->
                        <template v-else-if="(item.class_train_type === 'goalkeeper_education') && idx == 0 ">
                           <div class="td opt">
                            <p
                              :class="{
                                isEducation: true,
                              }"
                              :title="
                                item.is_score_unusual_stu
                                  | tipMsg(item.is_repetition_stu)
                              "
                            >
                              审核
                            </p>
                          </div>
                        </template>
                        <template v-else>
                          <div class="td opt">
                            <p
                              v-if="item.status != 'ScoreAudit' || idx != 0"
                              :class="{
                                unusual_err:
                                  item.is_score_unusual_stu == '1' &&
                                  item.is_repetition_stu == '0',
                                repetition_err:
                                  item.is_repetition_stu == '1' &&
                                  item.is_score_unusual_stu == '0',
                                both_err:
                                  item.is_repetition_stu == '1' &&
                                  item.is_score_unusual_stu == '1',
                                passClass_suc:
                                  item.is_repetition_stu == '0' &&
                                  item.is_score_unusual_stu == '0',
                              }"
                              @click="lookOver(item.c_id)"
                              :title="
                                item.is_score_unusual_stu
                                  | tipMsg(item.is_repetition_stu)
                              "
                            >
                              查看
                            </p>
                            <p
                              v-else
                              :class="{
                                unusual_err_stu:
                                  item.is_score_unusual_stu == '1' &&
                                  item.is_repetition_stu == '0',
                                repetition_stu:
                                  item.is_repetition_stu == '1' &&
                                  item.is_score_unusual_stu == '0',
                                both_err_stu:
                                  item.is_repetition_stu == '1' &&
                                  item.is_score_unusual_stu == '1',
                                passClass:
                                  item.is_repetition_stu == '0' &&
                                  item.is_score_unusual_stu == '0',
                              }"
                              @click="verify(index, item.c_id)"
                              :title="
                                item.is_score_unusual_stu
                                  | tipMsg(item.is_repetition_stu)
                              "
                            >
                              审核
                            </p>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
            <div class="paging">
              <yioks-paging
                :paging="paging"
                @goto-page="gotoPage($event)"
              ></yioks-paging>
            </div>
          </template>
          <div class="empty_wrap" v-show="showEmpty">
            <yioks-empty h="100%"></yioks-empty>
          </div>
        </template>
        <yioks-verify
          :flag="verifyFlag"
          :verifyBtn="true"
          :holderText="`如审核拒绝，可在此输入理由`"
          @hideVerify="hideVerifyDialog"
        ></yioks-verify>
      </div>
    </div>
  </div>
</template>

<script>
import ops from "@/assets/js/vuescrollOption";
import verifyMixin from "@/minix/system-editclass-router";
import {
  class_score_status,
  classLevelList,
  classLevelListForGoalkeeper,
  classLevelListForPhysical,
  classLevelListFive,
  class_train_type_list,
  levelName,
} from "@/assets/js/select";
import { statusKV, typeFilters, LevelFilters } from "@/assets/js/status";
import {
  orgList,
  classScoreList,
  classScoreVerify,
} from "@/api/system_manager/api";
import fiveMixins from "@/minix/fiveMixins";

export default {
  name: "class-manage",
  mixins: [fiveMixins, verifyMixin],
  data() {
    const nav = [
      {
        name: "未审核成绩",
        status: "ScoreAudit",
      },

      {
        name: "已拒绝成绩",
        status: "ScoreRefused",
      },
      {
        name: "培训班已完成",
        status: "Complete",
      },
      {
        name: "汇总表",
        status: "",
      },
    ];
    return {
      idx: 0, // nav 下标
      nav: nav,
      ops: ops(),
      selectStatus: class_score_status,
      class_levels: [],
      selectVal: {
        org_id: "",
        status: "",
        class_level: "", // 默认值earlt/D
        class_train_type: "",
        keywords: "",
        year: "",
      },
      isLoading: true,
      showList: false,
      showEmpty: false,
      organization: [],
      class_train_types: class_train_type_list,
      levelList: [],
      list: [],
      page: 1,
      paging: {
        start: 0, // 每页从第几条数据开始
        prePage: 1, // 一页多少条数据
        total: 0, // 总页数
        size: 3, // 页码显示限制
        last: true, // 尾页
        next: true, // 下一页
        first: true, // 首页
        previous: true, // 上一页
        jump: true,
      },
      isAddTea: false,
      verifyFlag: false,
      reqData: {
        idx: "", // 第几条
        id: "", // 培训班c_id
      },
    };
  },
  computed: {
    // 获取2019年至今的年份数组
    yearList(){
      let year = new Date().getFullYear();
      let yearList = [];
      for(var i = 0; i <= (year-2019); i++ ){
        yearList.push(
          {value:(2019+i), label:(2019+i)},
        );
      }
      return  yearList;
    }
  },
  components: {
    "class-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-paging": () => import("@/components/Pagination/Page"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-verify": () => import("@/components/Tips/verify-adjust-score"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
  },
  filters: {
    classStatus(status) {
      return (statusKV[status] || {}).text;
    },
    level(level) {
      if (!level) {
        return "--";
      }
      return LevelFilters(level);
    },
    tipMsg(is_score_unusual_stu, is_repetition_stu) {
      let msg = "";
      if (is_score_unusual_stu == "1" && is_repetition_stu == "0") {
        msg = "该培训班中存在成绩库成绩异常的学员";
      }
      if (is_score_unusual_stu == "0" && is_repetition_stu == "1") {
        msg = "该培训班中存在重复参加此类培训的学员";
      }
      if (is_score_unusual_stu == "1" && is_repetition_stu == "1") {
        msg = "该培训班中存在成绩库成绩异常、重复参加此类培训的学员";
      }
      return msg;
    },
    classType(level) {
      return typeFilters(level);
    },
    titleFilter(row, isFive) {
      if (row.class_level) {
        if (isFive) {
          return `${levelName[row.class_level]}`;
        } else {
          return `${levelName[row.class_level]}`;
        }
      } else {
        return "";
      }
    },
  },
  created() {
    this.setClassLevel();
    this.setData();
    this.request();
    this.getOrgList();
    console.log('isFive', this.isFive)
  },
  methods: {
    setClassLevel() {
      if (this.isFive) {
        this.class_levels = classLevelListFive.concat([
          { value: "", key: "全部" },
        ]);
        this.$set(this.selectVal, "class_level", "early");
      } else {
        this.class_levels = classLevelList.concat(classLevelListForGoalkeeper).concat(classLevelListForPhysical).concat([{ value: "", key: "全部" }]);
        this.$set(this.selectVal, "class_level", "D");
      }
    },
    switchType(str, type) {
      this.$set(this.selectVal, str, type);
      this.search();
    },
    setData() {
      const { idx, id, status, keywords, page, class_level, class_train_type,year } =
        this.$route.query;
      page && (this.page = page);
      (idx == 0 || idx) && (this.idx = idx);
      id && this.$set(this.selectVal, "org_id", id);
      class_train_type &&
        this.$set(this.selectVal, "class_train_type", class_train_type);
      status && this.$set(this.selectVal, "status", status);
      keywords && this.$set(this.selectVal, "keywords", keywords);
      if(year){
        this.$set(this.selectVal, "year", year);
      }else{
        if(idx ==2 || idx ==3){
          this.$set(this.selectVal, "year", new Date().getFullYear());
        }
      }
      if ("class_level" in this.$route.query) {
        this.$set(this.selectVal, "class_level", class_level);
      }
    },
    goBack() {
      this.$router.push("/system/sm");
    },
    request() {
      this.isLoading = true;
      const postData = {
        name: this.selectVal.keywords,
        status:
          Number(this.idx) === 3
            ? this.selectVal.status
            : this.nav[this.idx].status,
        org_id: this.selectVal.org_id,
        class_train_type: this.selectVal.class_train_type,
        class_level: this.selectVal.class_level,
        year: this.selectVal.year,
        page: this.page,
      };
      // console.log(postData);
      classScoreList(postData)
        .then((res) => {
          // console.log(res);
          const { status, result } = res.data;
          if (Number(status) === 0) {
            this.isLoading = false;
            this.list = result.list;
            this.levelList = result.levelList;
            this.$set(this.paging, "prePage", result.page.page_size);
            this.$set(this.paging, "total", result.page.total_row);
            this.$set(
              this.paging,
              "start",
              (this.page - 1) * this.paging.prePage
            );
            this.showList = result.list.length > 0;
            this.showEmpty = !this.showList;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    },
    getOrgList() {
      orgList({})
        .then((res) => {
          // console.log(res);
          const { status, result } = res.data;
          if (Number(status) === 0) {
            this.organization = result.organization;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    switchTab(idx) {
      if (Number(idx) === this.idx) return false;
      this.showList = false;
      const defaultClassLevel = this.isFive ? "early" : "D";
      this.$set(this.selectVal, "org_id", "");
      this.$set(this.selectVal, "class_train_type", "");
      this.$set(this.selectVal, "status", "");
      this.$set(this.selectVal, "keywords", "");
      this.$set(this.selectVal, "year", idx === 2 || idx === 3 ? new Date().getFullYear() :"");
      this.$set(this.selectVal, "class_level", defaultClassLevel);
      this.idx = idx;
      this.changeQuery(true);
    },
    toSocreHis() {
      this.$router.replace({
        path: "/system/history_score",
        query: {},
      });
    },
    search() {
      this.changeQuery(true);
    },
    hideIcon() {
      this.$set(this.selectVal, "keywords", "");
      this.changeQuery(true);
    },
    gotoPage(start) {
      this.page = parseInt(start / this.paging.prePage) + 1;
      this.changeQuery(false);
      this.$refs["vs"].scrollTo({ y: 0 });
    },
    changeQuery(flag) {
      flag && (this.page = 1);
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          idx: this.idx,
          id: this.selectVal.org_id,
          class_train_type: this.selectVal.class_train_type,
          keywords: this.selectVal.keywords,
          class_level: this.selectVal.class_level,
          year: this.selectVal.year,
          page: this.page,
          status: this.selectVal.status,
        },
      });
      this.request();
    },
    lookOver(id) {
      this.$router.push({
        path: "look_score",
        query: {
          c_id: id,
        },
      });
    },
    verify(idx, c_id) {
      this.verifyFlag = true;
      this.$set(this.reqData, "idx", idx);
      this.$set(this.reqData, "id", c_id);
    },
    hideVerifyDialog(bool, params, msg, isSendSms) {
      this.verifyFlag = false;
      if (bool) {
        classScoreVerify({
          c_id: this.reqData.id,
          status: params,
          msg_info: msg,
          isSendSms: isSendSms,
        })
          .then((res) => {
            // console.log(res);
            const { status, msg } = res.data;
            if (Number(status) === 0) {
              params === "Y"
                ? this.$set(
                    this.list[this.reqData.idx],
                    "status",
                    "ScoreAffirm"
                  )
                : this.$set(
                    this.list[this.reqData.idx],
                    "status",
                    "ScoreRefused"
                  );
              this.$message.success("审核成功");
            } else {
              this.$message.error(msg);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/nav_filter'
.score_man-root
  zuxie-page-root()
  .main-content-wrap
    color $color_white
    font-size $font_size_medium
    line-height inherit
    .nav_filter_wrap
      .score_his
        text-decoration underline
        font-style italic
        line-height 1
        cursor pointer
      .filter_line
        .level_fox
          margin-right 5px
          .item
            padding: 3px 6px;
.classMain
  position relative
  display flex
  flex-direction column
  height 620px
  width 100%
  padding 20px 0 0
  background-color $block_bg_color_base
  .searchWrap
    display flex
    justify-content space-between
    align-items center
    height 40px
    margin 0 40px 30px
    .selectWrap
      height 100%
      display flex
      select
        width 120px
        // height: 100%;
        padding 0 15px
        font-size $font_size_medium
        color $color_black
        outline none
        &+select
          margin-left 10px
    .search
      width 390px
      height 100%
      display flex
      justify-content flex-end
      // align-items: center;
      .wrap
        height 100%
        position relative
        input
          width 180px
          height 100%
          padding 0 20px
          font-size $font_size_medium
          color $color_black
          outline none
        .close
          position absolute
          right 5px
          top 10px
          color $color_info
          cursor pointer
      .searchBtn
        width 90px
        // height: 100%;
        display flex
        justify-content center
        align-items center
        font-size 20px
        background-color $color_suc
        cursor pointer
        user-select none
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        height 45px
        display flex
    .scrollArea
      height 425px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        height 49px
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height 100%
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        over_hide()
        color $color_white
      .unusual_err
        color $color_unusual
      .both_err
        color $color_both_err
      .repetition_err
        color $color_tip_red
      .passClass_suc
        color $color_suc
      .both_err_stu
        background-color $color_both_err
      .unusual_err_stu
        background-color $color_unusual
      .repetition_stu
        background-color $color_tip_red
      .passClass
        background-color $color_suc
      .isEducation
        background-color $color_background_grey
        cursor no-drop
    /* .class_name {
      width: 26%;
      p {
        cursor: pointer;
      }
      .repetition_stu{
        color:$color_err;
      }
    } */
    .index
      width 6%
    .org
      width 20%
    .periods, .opt
      width 11%
      p
        width 75px
        height 35px
        display flex
        justify-content center
        align-items center
        cursor pointer
        user-select none
    .level
      width 14%
    .date
      width 25%
    .status
      width 13%
      .subStatus
        font-size 12px
    /* .opt {
      width: 11%;
      span {
        width: 80px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
      }
    } */
  .empty_wrap
    flex 1
    width 100%
  .paging
    width 100%
    // height: 60px;
    padding 25px 0 10px
</style>
